import { NapaDialogConfig } from '@shared/modules/dialog/models/dialog.models';

export const UNSAVED_CHANGES_DIALOG_CONFIG: NapaDialogConfig = {
  title: 'Are you sure you want to leave?',
  body: 'You have unsaved changes. Are you sure you want to leave this page?',
  hasPrimaryBtn: true,
  hasSecondaryBtn: true,
  closeOnButtonClick: true,
  secondaryBtnText: 'Cancel',
  primaryBtnText: 'Confirm',
};

export const CHECKED_INTAKE_DIALOG_CONFIG: NapaDialogConfig = {
  title: 'Intake Form Reminder',
  body: 'You haven\'t completed the intake form yet. While you can proceed with registration, we recommend completing it as soon as possible.',
  hasPrimaryBtn: true,
  hasSecondaryBtn: true,
  closeOnButtonClick: true,
  secondaryBtnText: 'Go Back',
  primaryBtnText: 'Continue with Registration',
};
